(function ($) {
    //START NAVIGATION
        // RESETS LAYOUT IF NEEDED
        resetLayout();

        $(window).on('resize', resetLayout);
        $(window).on('scroll', toggleScroll);

        $(".js-open-menu").on("click", toggleActive);

        function resetLayout() {
            setTimeout(() => {
                $headerMarginHeight = $('.header').outerHeight(true);
                $headerHeight = $('.header').outerHeight(false);

                if ($(window).width() > 1400 && $('body').hasClass('hero-first')) {
                    $headerBottomHeight = $('.header__bottom').outerHeight(true) + 1;
                    $headerHeight = $headerHeight - $headerBottomHeight;

                    if($('.banner-popup-container:not(.hidden)').length > 0) {
                        $headerHeight = $headerHeight - $('.banner-popup-container').outerHeight(true);
                    }
                }

                //$('.header__navigation__menu').css('paddingTop', $headerMarginHeight);
                $('main#content').css('paddingTop', $headerHeight);
            }, 50);
        }

        function toggleActive(e) {
            resetLayout();
            $(this).toggleClass("is-active");
            $(".header__navigation__menu").toggleClass("active");

            // Smooth transition of mobile navigation => prevents moving items on resizing
            if ($(".header__navigation__menu").hasClass("smooth")) {
                setTimeout(() => {
                    $(".header__navigation__menu").removeClass("smooth");
                }, 500);
            } else {
                $(".header__navigation__menu").addClass("smooth");
            }
        }

        function toggleScroll(e) {
            resetLayout();
            if ($(this).scrollTop() >= 50) {
                $(".header").addClass("scrolled");
            } else {
                $(".header").removeClass("scrolled");
            }
        }
    //END NAVIGATION

    //START SCROLLED
        $(window).on("resize", function () {
            if ($(this).scrollTop() >= 50) {
                $(".header").addClass("scrolled");
            } else {
                $(".header").removeClass("scrolled");
            }
        });
    //END SCROLLED

    //START SET MC4WP LANGUAGE
       // Language code to full language name mapping
        var languageMap = {
            'en': 'English',
            'fr': 'French',
            'nl': 'Dutch',
            'de': 'German',
            'es': 'Spanish',
            'it': 'Italian'
        };
    
        // Extract language code from the 'lang' attribute on the <html> element
        var currentLang = $("html").attr("lang").split("-")[0]; // Get language code part (e.g., 'en' from 'en-US')
    
        // Get the full language name, defaulting to 'English' if not found
        var languageName = languageMap[currentLang] || 'English';
    
        // Set the full language name in the hidden input field
        $('input.mc4wp-language').val(languageName); 
    //END SET MC4WP LANGUAGE

    //START SET REFER A FRIEND COPY BUTTON
        // Set the full language name in the hidden input field
        $('.js-refer-a-friend__copy-btn').click(function () {
            // Get the input element
            var copyText = $('#referral-link');
    
            // Select the text inside the input
            copyText.select();
            copyText[0].setSelectionRange(0, 99999); // For mobile devices
    
            // Copy the text to clipboard
            document.execCommand('copy');
    
            // Optional: Show a success message
            alert('Copied: ' + copyText.val());
        });
    //END SET REFER A FRIEND COPY BUTTON
    
    //START NICE NUMBER
        $('.nice-number button').on('click', function () {
            var $input = $(this).siblings('input.qty');
            var currentValue = parseInt($input.val()) || 1;
            var max = parseInt($input.attr('max')) || 999;
            var min = parseInt($input.attr('min')) || 1;
            var step = parseInt($input.attr('step')) || 1;
    
            // console.log(currentValue);

            if ($(this).text() === "+") {
                if (currentValue < max) {
                    $input.val(currentValue + step).trigger('change');
                }
            } 
            // else {
            //     if (currentValue > min) {
            //         $input.val(currentValue - step).trigger('change');
            //     }
            // }
        });
    //END NICE NUMBER
})(jQuery);
